<template>
  <div>
    <div class="row">
      <div class="col-sm"></div>
    </div>
  </div>
</template>

<script>
export default {};
</script>
